export enum ChromeExtensionMessageType {
  URL_UPDATED = 'URL_UPDATED',
  IFRAME_READY = 'IFRAME_READY',
  BACKGROUND_READY = 'BACKGROUND_READY',
  FETCH_DOM_CONTENT = 'FETCH_DOM_CONTENT',
  /** Clicks DAT equipment rows to expand FMCSA panels (use only on explicit user action). */
  FETCH_DAT_EQUIPMENT_EXPANDED_DOM = 'FETCH_DAT_EQUIPMENT_EXPANDED_DOM',
  SEND_DOM_CONTENT = 'SEND_DOM_CONTENT',
  SEND_DAT_EQUIPMENT_EXPANDED_DOM = 'SEND_DAT_EQUIPMENT_EXPANDED_DOM',
  FETCH_OTHER_PAGE = 'FETCH_OTHER_PAGE',
  FETCH_DOM_IFRAME_CONTENT = 'FETCH_DOM_IFRAME_CONTENT',
  SEND_DOM_IFRAME_CONTENT = 'SEND_DOM_IFRAME_CONTENT',
  UNSUPPORTED_URL = 'UNSUPPORTED_URL',
  OPEN_GMAIL_SIDEBAR = 'OPEN_GMAIL_SIDEBAR',
  INITIATE_AUTH_FLOW = 'INITIATE_AUTH_FLOW',
  RELAY_AUTH_TOKEN = 'RELAY_AUTH_TOKEN',
}

export type ExtensionMessage = {
  type: ChromeExtensionMessageType;
  payload?: string;
  tabId?: number;
  approvedHostname?: string;
};
